/*
 * PS-FILTRE (comportement)
 * Ajoute, par-dessus les filtres NATIFS Shopify/Dawn (aucune logique de
 * filtrage réécrite) :
 *  - un bouton "Voir X résultats" en bas de la carte filtres desktop,
 *    synchronisé en direct avec le compteur natif Dawn ;
 *  - une pastille de couleur (+ info-bulle) devant chaque valeur du filtre
 *    "Couleur", déduite du NOM de la valeur (le metachamp est un simple
 *    texte, donc Shopify ne peut pas générer de pastille lui-même) via une
 *    table de correspondance nom -> couleur ci-dessous. Nom non reconnu =
 *    pas de pastille (dégradation silencieuse) ;
 *  - deux curseurs natifs Min/Max SÉPARÉS (l'un sous l'autre, pas
 *    superposés) au-dessus des champs Min/Max natifs des filtres de VRAIE
 *    plage numérique (aujourd'hui : Prix uniquement) : pilotent les mêmes
 *    champs texte que Dawn utilise déjà pour filtrer ;
 *  - pour le filtre "Poids", qui côté Shopify est une LISTE de tranches à
 *    cocher (pas une plage), un curseur "Poids maximum" qui coche/décoche
 *    directement les cases existantes selon leur valeur puis déclenche le
 *    filtrage natif Dawn normalement — pas de nouvelle logique de filtrage,
 *    juste une autre façon de cocher les mêmes cases.
 * Ces ajouts se réappliquent automatiquement après chaque mise à jour AJAX
 * des filtres (Dawn remplace le contenu HTML des filtres non modifiés à
 * chaque changement), via un MutationObserver.
 *
 * LIGNE D'APPEL ajoutée dans : sections/main-collection-product-grid.liquid
 * Juste après : <script src="{{ 'facets.js' | asset_url }}" defer="defer"></script>
 * Ligne ajoutée : <script src="{{ 'ps-filtre.js' | asset_url }}" defer="defer"></script>
 */
(function () {
  function addResultsButton() {
    var form = document.getElementById('FacetFiltersForm');
    var wrapper = document.getElementById('FacetsWrapperDesktop');
    if (!form || !wrapper || document.getElementById('PsFiltreResultsButton')) return;

    var countSource = document.getElementById('ProductCountDesktop') || document.getElementById('ProductCount');

    var button = document.createElement('button');
    button.type = 'button';
    button.id = 'PsFiltreResultsButton';
    button.className = 'button button--primary ps-filtre-results-button';

    function updateLabel() {
      var countText = countSource ? countSource.textContent.trim() : '';
      button.textContent = countText ? 'Voir ' + countText : 'Voir les résultats';
    }

    updateLabel();
    wrapper.appendChild(button);

    if (countSource) {
      var observer = new MutationObserver(updateLabel);
      observer.observe(countSource, { childList: true, characterData: true, subtree: true });
    }

    button.addEventListener('click', function () {
      var FacetFiltersFormElement = customElements.get('facet-filters-form');
      if (!FacetFiltersFormElement) return;
      var formData = new FormData(form);
      var searchParams = new URLSearchParams(formData).toString();
      FacetFiltersFormElement.renderPage(searchParams);
    });
  }

  // ---------------------------------------------------------------------
  // Pastilles couleur
  // ---------------------------------------------------------------------

  // Table de correspondance nom de couleur (FR, sans accent, minuscule) -> couleur CSS.
  // Les entrées composées (ex: "bleu vert") sont vérifiées avant les entrées simples.
  var PS_FILTRE_COLOR_MAP = [
    ['multicolore', 'conic-gradient(#dc2626,#f59e0b,#facc15,#16a34a,#2563eb,#7c3aed,#dc2626)'],
    ['bicolore', 'linear-gradient(90deg,#2563eb 50%,#f59e0b 50%)'],
    ['bleu vert', '#0d9488'],
    ['vert bleu', '#0d9488'],
    ['jaune vert', '#a3b100'],
    ['vert jaune', '#a3b100'],
    ['rose orange', '#f4694c'],
    ['orange rose', '#f4694c'],
    ['gris bleu', '#64748b'],
    ['bleu clair', '#60a5fa'],
    ['bleu fonce', '#1e3a8a'],
    ['vert fonce', '#166534'],
    ['vert clair', '#86efac'],
    ['rose pale', '#fbcfe8'],
    ['rose fonce', '#db2777'],
    ['bleu', '#2563eb'],
    ['rouge', '#dc2626'],
    ['vert', '#16a34a'],
    ['jaune', '#facc15'],
    ['orange', '#f97316'],
    ['rose', '#ec4899'],
    ['violet', '#7c3aed'],
    ['mauve', '#9d6fb0'],
    ['pourpre', '#7e22ce'],
    ['lilas', '#c9a0e0'],
    ['noir', '#111111'],
    ['noire', '#111111'],
    ['blanc', '#ffffff'],
    ['blanche', '#ffffff'],
    ['gris', '#9ca3af'],
    ['grise', '#9ca3af'],
    ['violette', '#7c3aed'],
    ['verte', '#16a34a'],
    ['marron', '#7c4a26'],
    ['brun', '#7c4a26'],
    ['brune', '#7c4a26'],
    ['beige', '#e8dcc8'],
    ['champagne', '#f2debb'],
    ['ivoire', '#fffff0'],
    ['creme', '#fdf6e3'],
    ['turquoise', '#14b8a6'],
    ['dore', '#d4af37'],
    ['or', '#d4af37'],
    ['argente', '#c0c0c0'],
    ['ambre', '#f2b90b'],
    ['incolore', '#ffffff'],
    ['transparent', '#ffffff']
  ];

  // Supprime les accents (décompose en NFD puis retire les marques diacritiques
  // U+0300-U+036F, construites via code point pour éviter tout souci d'encodage
  // du fichier source) et met à plat la ponctuation.
  var DIACRITICS_PATTERN = new RegExp('[' + String.fromCharCode(768) + '-' + String.fromCharCode(879) + ']', 'g');

  function normalize(str) {
    return str
      .toLowerCase()
      .normalize('NFD')
      .replace(DIACRITICS_PATTERN, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function findColor(label) {
    var normalized = normalize(label);
    for (var i = 0; i < PS_FILTRE_COLOR_MAP.length; i++) {
      if (normalized === PS_FILTRE_COLOR_MAP[i][0]) return PS_FILTRE_COLOR_MAP[i][1];
    }
    var words = normalized.split(' ');
    for (var w = 0; w < words.length; w++) {
      for (var j = 0; j < PS_FILTRE_COLOR_MAP.length; j++) {
        if (words[w] === PS_FILTRE_COLOR_MAP[j][0]) return PS_FILTRE_COLOR_MAP[j][1];
      }
    }
    return null;
  }

  // Identifie à quoi correspond un filtre à partir de son libellé affiché,
  // pour lui appliquer un comportement dédié (grille de pastilles pour
  // Couleur, pas de 1 en partant de 0 pour Poids).
  function getFilterKind(disclosure) {
    var labelEl = disclosure.querySelector('.facets__summary-label, .facets__summary span');
    if (!labelEl) return null;
    var norm = normalize(labelEl.textContent);
    if (norm.indexOf('couleur') !== -1) return 'couleur';
    if (norm.indexOf('poids') !== -1) return 'poids';
    return null;
  }

  function enhanceColorSwatches() {
    var wrapper = document.getElementById('FacetsWrapperDesktop');
    if (!wrapper) return;

    var disclosures = wrapper.querySelectorAll('.facets__disclosure-vertical');
    disclosures.forEach(function (disclosure) {
      if (getFilterKind(disclosure) !== 'couleur') return;

      // Marque le filtre Couleur pour lui appliquer une grille de pastilles
      // compacte plutôt que la liste verticale texte des autres filtres.
      disclosure.classList.add('ps-filtre-color-filter');

      var labels = disclosure.querySelectorAll('.facet-checkbox');
      labels.forEach(function (label) {
        var textLabelEl = label.querySelector('.facet-checkbox__text-label');
        var textNode = label.querySelector('.facet-checkbox__text');
        if (!textLabelEl || !textNode || textNode.dataset.psFiltreDot === 'true') return;

        var colorName = textLabelEl.textContent.trim();
        var color = findColor(colorName);
        textNode.dataset.psFiltreDot = 'true';
        if (!color) return;

        var dot = document.createElement('span');
        dot.className = 'ps-filtre-color-dot';
        dot.style.background = color;
        dot.setAttribute('aria-hidden', 'true');
        textNode.insertBefore(dot, textNode.firstChild);
        label.title = colorName;
      });
    });
  }

  // ---------------------------------------------------------------------
  // Curseurs natifs (Min et Max séparés, PAS superposés) pour les filtres
  // de plage (Prix, Poids). Après plusieurs échecs sur un montage à deux
  // curseurs empilés en une seule barre (bugs de superposition impossibles
  // à corriger sans accès direct au rendu), on privilégie la fiabilité :
  // deux <input type="range"> ordinaires, stylés uniquement via
  // accent-color, sans position absolue ni pseudo-éléments à faire échouer.
  // ---------------------------------------------------------------------

  // Shopify formate data-min/data-max/value au format de la boutique
  // (ex: data-max="1.666,00" — point = séparateur de milliers, virgule =
  // décimales), pas au format JS attendu par parseFloat (qui lisait
  // "1.666,00" comme 1.666 et cassait toute la borne max). Si une virgule
  // est présente, on retire les points (milliers) puis on remplace la
  // virgule par un point avant de parser.
  function parseLocaleNumber(str) {
    if (str == null) return NaN;
    str = String(str).trim();
    if (str.indexOf(',') !== -1) {
      str = str.replace(/\./g, '').replace(',', '.');
    }
    return parseFloat(str);
  }

  function enhancePriceRange(rangeEl, opts) {
    opts = opts || {};

    // Retire la hauteur max + ascenseur (pensés pour les longues listes de
    // cases à cocher) : un filtre de plage n'a jamais besoin de défiler.
    var disclosure = rangeEl.closest('.facets__disclosure-vertical');
    if (disclosure) disclosure.classList.add('ps-filtre-range-filter');

    if (rangeEl.querySelector('.ps-filtre-range')) return;

    var inputs = rangeEl.querySelectorAll('input.field__input');
    if (inputs.length < 2) return;

    var minField = inputs[0];
    var maxField = inputs[1];
    var min = opts.forceMin != null ? opts.forceMin : parseLocaleNumber(minField.getAttribute('data-min') || '0');
    var max = parseLocaleNumber(maxField.getAttribute('data-max') || minField.getAttribute('data-max') || '0');
    if (!isFinite(min) || !isFinite(max) || max <= min) return;

    var decimals = opts.decimals != null ? opts.decimals : 2;
    var stepValue = opts.step != null ? opts.step : (max - min) / 100;
    var factor = Math.pow(10, decimals);

    var startMin = minField.value !== '' ? parseLocaleNumber(minField.value) : min;
    var startMax = maxField.value !== '' ? parseLocaleNumber(maxField.value) : max;

    var wrap = document.createElement('div');
    wrap.className = 'ps-filtre-range';
    wrap.innerHTML =
      '<div class="ps-filtre-range__row">' +
      '<span class="ps-filtre-range__row-label">Min</span>' +
      '<input type="range" class="ps-filtre-range__input ps-filtre-range__input--min" aria-label="Valeur minimum">' +
      '</div>' +
      '<div class="ps-filtre-range__row">' +
      '<span class="ps-filtre-range__row-label">Max</span>' +
      '<input type="range" class="ps-filtre-range__input ps-filtre-range__input--max" aria-label="Valeur maximum">' +
      '</div>';
    rangeEl.insertBefore(wrap, rangeEl.firstChild);

    var minRange = wrap.querySelector('.ps-filtre-range__input--min');
    var maxRange = wrap.querySelector('.ps-filtre-range__input--max');

    [minRange, maxRange].forEach(function (rangeInput) {
      rangeInput.min = min;
      rangeInput.max = max;
      rangeInput.step = stepValue;
    });
    minRange.value = startMin;
    maxRange.value = startMax;

    function commit() {
      minField.value = Math.round(parseFloat(minRange.value) * factor) / factor;
      maxField.value = Math.round(parseFloat(maxRange.value) * factor) / factor;
      minField.dispatchEvent(new Event('input', { bubbles: true }));
    }

    minRange.addEventListener('input', function () {
      if (parseFloat(minRange.value) > parseFloat(maxRange.value)) minRange.value = maxRange.value;
    });
    maxRange.addEventListener('input', function () {
      if (parseFloat(maxRange.value) < parseFloat(minRange.value)) maxRange.value = minRange.value;
    });
    minRange.addEventListener('change', commit);
    maxRange.addEventListener('change', commit);

    minField.addEventListener('input', function () {
      if (minField.value !== '') minRange.value = parseLocaleNumber(minField.value);
    });
    maxField.addEventListener('input', function () {
      if (maxField.value !== '') maxRange.value = parseLocaleNumber(maxField.value);
    });
  }

  function enhanceAllPriceRanges() {
    var wrapper = document.getElementById('FacetsWrapperDesktop');
    if (!wrapper) return;

    var disclosures = wrapper.querySelectorAll('.facets__disclosure-vertical');
    disclosures.forEach(function (disclosure) {
      var rangeEl = disclosure.querySelector('price-range');
      if (!rangeEl) return;

      if (getFilterKind(disclosure) === 'poids') {
        // Poids : pas de 1 en partant de 0, valeurs entières (pas de décimales).
        enhancePriceRange(rangeEl, { forceMin: 0, step: 1, decimals: 0 });
      } else {
        enhancePriceRange(rangeEl, {});
      }
    });
  }

  // ---------------------------------------------------------------------
  // Poids : PAS un vrai filtre de plage côté Shopify (c'est une liste de
  // tranches à cocher : "0-1 ct", "1ct", "2ct"...). Faute de min/max natif
  // à piloter, on triche : deux curseurs Min/Max qui cochent/décochent
  // directement les cases existantes selon leur valeur, puis déclenchent
  // le filtrage natif Dawn normalement (aucune requête ni logique de
  // filtrage réécrite, juste des clics simulés sur les cases réelles).
  // Mise à jour sur "input" (en direct pendant qu'on glisse), pas
  // seulement "change" (relâchement) — sinon rien ne semble bouger tant
  // qu'on n'a pas lâché la souris.
  // ---------------------------------------------------------------------

  function parseWeightValue(label) {
    var trimmed = label.trim();
    if (/^</.test(trimmed)) return 0;
    var match = trimmed.match(/(\d+)/);
    return match ? parseInt(match[1], 10) : null;
  }

  function enhanceWeightSlider() {
    var wrapper = document.getElementById('FacetsWrapperDesktop');
    if (!wrapper) return;

    var disclosures = wrapper.querySelectorAll('.facets__disclosure-vertical');
    disclosures.forEach(function (disclosure) {
      if (getFilterKind(disclosure) !== 'poids') return;
      if (disclosure.querySelector('.ps-filtre-weight-slider')) return;

      // Masque la liste de cases à cocher natives (une par tranche de poids) :
      // le curseur ci-dessous les pilote déjà en coulisses, l'afficher en plus
      // n'apporte rien à l'utilisateur.
      disclosure.classList.add('ps-filtre-weight-filter');

      var display = disclosure.querySelector('.facets__display-vertical');
      if (!display) return;

      var items = Array.prototype
        .slice.call(disclosure.querySelectorAll('.facet-checkbox'))
        .map(function (label) {
          var textLabelEl = label.querySelector('.facet-checkbox__text-label');
          var input = label.querySelector('input[type="checkbox"]');
          if (!textLabelEl || !input) return null;
          var value = parseWeightValue(textLabelEl.textContent);
          if (value == null) return null;
          return { value: value, input: input };
        })
        .filter(Boolean);

      if (items.length === 0) return;

      var values = items.map(function (item) {
        return item.value;
      });
      var min = Math.min.apply(null, values);
      var max = Math.max.apply(null, values);
      if (max <= min) return;

      var checkedValues = items
        .filter(function (item) {
          return item.input.checked;
        })
        .map(function (item) {
          return item.value;
        });
      var initialMin = checkedValues.length ? Math.min.apply(null, checkedValues) : min;
      var initialMax = checkedValues.length ? Math.max.apply(null, checkedValues) : max;

      var wrap = document.createElement('div');
      wrap.className = 'ps-filtre-weight-slider';
      wrap.innerHTML =
        '<div class="ps-filtre-range__row">' +
        '<span class="ps-filtre-range__row-label">Min</span>' +
        '<input type="range" class="ps-filtre-range__input ps-filtre-weight-slider__input--min" aria-label="Poids minimum">' +
        '<span class="ps-filtre-weight-slider__value ps-filtre-weight-slider__value--min"></span>' +
        '</div>' +
        '<div class="ps-filtre-range__row">' +
        '<span class="ps-filtre-range__row-label">Max</span>' +
        '<input type="range" class="ps-filtre-range__input ps-filtre-weight-slider__input--max" aria-label="Poids maximum">' +
        '<span class="ps-filtre-weight-slider__value ps-filtre-weight-slider__value--max"></span>' +
        '</div>';
      display.insertBefore(wrap, display.firstChild);

      var minRange = wrap.querySelector('.ps-filtre-weight-slider__input--min');
      var maxRange = wrap.querySelector('.ps-filtre-weight-slider__input--max');
      var minValueLabel = wrap.querySelector('.ps-filtre-weight-slider__value--min');
      var maxValueLabel = wrap.querySelector('.ps-filtre-weight-slider__value--max');

      [minRange, maxRange].forEach(function (rangeInput) {
        rangeInput.min = min;
        rangeInput.max = max;
        rangeInput.step = 1;
      });
      minRange.value = initialMin;
      maxRange.value = initialMax;

      function apply() {
        var minVal = parseInt(minRange.value, 10);
        var maxVal = parseInt(maxRange.value, 10);
        minValueLabel.textContent = minVal + ' ct';
        maxValueLabel.textContent = maxVal + ' ct';
        items.forEach(function (item) {
          item.input.checked = item.value >= minVal && item.value <= maxVal;
        });
      }

      apply();

      // Un <input type="range"> natif émet déjà un évènement "input" qui
      // remonte tout seul jusqu'au formulaire (le debounce de Dawn s'en
      // charge) — pas besoin d'en redéclencher un manuellement ici. On
      // met juste à jour les cases à cocher AVANT que cet évènement natif
      // n'atteigne le formulaire, pour que Dawn lise le bon état.
      minRange.addEventListener('input', function () {
        if (parseInt(minRange.value, 10) > parseInt(maxRange.value, 10)) minRange.value = maxRange.value;
        apply();
      });
      maxRange.addEventListener('input', function () {
        if (parseInt(maxRange.value, 10) < parseInt(minRange.value, 10)) maxRange.value = minRange.value;
        apply();
      });
    });
  }

  // ---------------------------------------------------------------------
  // Pastilles "filtre actif" (en haut de la sidebar) : comme le curseur de
  // poids coche une case par tranche couverte, Dawn affiche une pastille
  // par case cochée ("Poids: 12ct", "Poids: 15ct"...) — la plage est déjà
  // lisible dans le curseur lui-même, ces pastilles sont juste du bruit.
  // ---------------------------------------------------------------------

  function hideWeightPills() {
    var container = document.querySelector('#FacetsWrapperDesktop .active-facets-desktop');
    if (!container) return;

    var pills = container.querySelectorAll(':scope > facet-remove');
    pills.forEach(function (pill) {
      var label = pill.querySelector('.active-facets__button-inner');
      if (!label) return;
      if (normalize(label.textContent).indexOf('poids') === 0) {
        pill.classList.add('ps-filtre-hidden-pill');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    addResultsButton();
    enhanceColorSwatches();
    enhanceAllPriceRanges();
    enhanceWeightSlider();
    hideWeightPills();

    var wrapper = document.getElementById('FacetsWrapperDesktop');
    if (wrapper) {
      var observer = new MutationObserver(function () {
        enhanceColorSwatches();
        enhanceAllPriceRanges();
        enhanceWeightSlider();
        hideWeightPills();
      });
      observer.observe(wrapper, { childList: true, subtree: true });
    }
  });
})();
